import { Chip, Tooltip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Block } from "@mui/icons-material";

interface Props {
  notBookedPercentage: string;
}

export function NoBookingTimeAverage({ notBookedPercentage }: Readonly<Props>) {
  const { t } = useTranslation();

  return (
    <Tooltip
      title={<Typography>{t("NoBookingTimeAverageLabel")}</Typography>}
      aria-label={"NoBookingTimeAverageLabel"}
    >
      <Chip
        sx={{ mr: 1, mb: 1 }}
        data-testid={"no-booking-time-average-label"}
        icon={<Block />}
        label={notBookedPercentage}
        color={"warning"}
      />
    </Tooltip>
  );
}
